<template>
  <v-snackbar
    location="left bottom"
    class="fontlao"
    v-model="dialog"
    color="error"
    right
  >
    {{ msg }}
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    msg: {
      get() {
        return this.$store.state.msg;
      },
    },
    dialog: {
      set(val) {
        this.$store.commit("snackbarFailed", { value: val });
      },
      get() {
        return this.$store.state.snackbarFailed;
      },
    },
  },
};
</script>

<style></style>
